module.exports = __webpack_public_path__ + "img/hospitality-splash.4b984d40.svg";